module.exports = __webpack_public_path__ + "img/7.77a50e91.png";